// Eget rabattkodsfält i kassan (lw_checkout_coupon_field).
// Applicerar/tar bort kupong via AJAX (lw_apply_coupon / lw_remove_coupon) och triggar
// sedan update_checkout så att WC räknar om order review + totaler.
//
// Fältet ligger inuti order review-tabellen (efter delsumman), som update_checkout byter ut.
// Applicerade kuponger renderas därför färskt från servern vid omräkningen, medan senaste
// notis återinjiceras här efter "updated_checkout" (annars hade den rensats vid omritningen).
(function () {
    const WIDGET_ID = 'lw-coupon'

    // Notis som ska visas igen efter att update_checkout ritat om fältet. null = inget väntande.
    let pendingNotices = null

    // Öppet/stängt-läge för <details> bevaras över omritningar (update_checkout byter ut fältet).
    let wasOpen = false

    function ajaxUrl() {
        return window.liGlobal?.ajaxUrl || '/wp-admin/admin-ajax.php'
    }

    function refreshCheckout() {
        if (window.jQuery) {
            window.jQuery(document.body).trigger('update_checkout')
        }
    }

    function widget() {
        return document.getElementById(WIDGET_ID)
    }

    function setNotices(html) {
        const el = widget()
        const noticesEl = el && el.querySelector('.lw-coupon-notices')
        if (noticesEl) noticesEl.innerHTML = html || ''
    }

    // Innan WC ritar om: kom ihåg om fältet var öppet så vi kan återställa det.
    // Efter omritningen: återställ öppet-läge + senaste notis i det nya fältet.
    if (window.jQuery) {
        window.jQuery(document.body).on('update_checkout', function () {
            const el = widget()
            if (el) wasOpen = el.open
        })

        window.jQuery(document.body).on('updated_checkout', function () {
            const el = widget()
            if (el && wasOpen) el.open = true

            if (pendingNotices === null) return
            setNotices(pendingNotices)
            pendingNotices = null
        })
    }

    // Skicka AJAX-anrop och uppdatera fältet med svaret.
    function post(action, couponCode) {
        const el = widget()
        if (!el) return

        const nonce = el.dataset.nonce || ''
        const noticesEl = el.querySelector('.lw-coupon-notices')
        const appliedEl = el.querySelector('.lw-coupon-applied')
        const applyBtn = el.querySelector('.lw-coupon-apply')

        if (applyBtn) applyBtn.disabled = true
        el.querySelectorAll('.lw-coupon-remove').forEach((b) => (b.disabled = true))

        const body = new URLSearchParams({
            action,
            nonce,
            coupon_code: couponCode,
        })

        fetch(ajaxUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString(),
        })
            .then((r) => r.json())
            .then((res) => {
                const data = res?.data || {}
                // Direkt feedback i nuvarande fält ...
                if (noticesEl) noticesEl.innerHTML = data.notices || ''
                if (appliedEl) appliedEl.innerHTML = data.coupons || ''
                // ... och spara notisen så den återställs efter att update_checkout ritat om fältet.
                pendingNotices = data.notices || ''
                refreshCheckout()
            })
            .catch(() => {
                if (noticesEl) {
                    noticesEl.innerHTML =
                        '<div class="woocommerce-error">' +
                        'Något gick fel. Försök igen.' +
                        '</div>'
                }
            })
            .finally(() => {
                if (applyBtn) applyBtn.disabled = false
            })
    }

    function applyCoupon() {
        const input = document.getElementById('lw-coupon-code')
        if (!input) return
        const code = input.value.trim()
        if (!code) return
        post('lw_apply_coupon', code)
        input.value = ''
    }

    // Delegerade events — fältet kan re-renderas vid behov.
    document.addEventListener('click', function (e) {
        const applyBtn = e.target.closest('.lw-coupon-apply')
        if (applyBtn) {
            e.preventDefault()
            applyCoupon()
            return
        }

        const removeBtn = e.target.closest('.lw-coupon-remove')
        if (removeBtn) {
            e.preventDefault()
            post('lw_remove_coupon', removeBtn.dataset.coupon || '')
        }
    })

    // Enter i inputfältet ska applicera, inte posta checkout-formuläret.
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return
        if (e.target && e.target.id === 'lw-coupon-code') {
            e.preventDefault()
            applyCoupon()
        }
    })
})()
